import React from 'react';
import LcIconLink from '../../Generic/LcIconLink';

import './index.css';

interface Props {
    title?: string | React.ReactNode,
    close: Function,
    visible: boolean,
    width?: string
    height?: string
}

const Modal: React.FC<Props> = (props) => {

    return (
        <div className="dialog-modal">
            {
                props.visible &&
                <div className="all" onClick={() => { !props.title && props.close(false) }}>
                    <div className="content" style={{ width: props.width || '600px', height: props.height || "" }}>
                        {/* <div className="content" style={{ width: props.width }}> */}
                        {
                            props.title &&
                            <div className="header">
                                <div className="title">
                                    {
                                        (typeof props.title === 'string')
                                            ? <span>{props.title}</span>
                                            : props.title
                                    }
                                </div>
                                <LcIconLink icon='ppi ppi-x' tooltip='Fechar' onClick={() => props.close(false)} />
                            </div>
                        }
                        <div className="body">
                            {props.children}
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default Modal;